(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("web3"), require("web3-eth-abi"));
	else if(typeof define === 'function' && define.amd)
		define(["web3", "web3-eth-abi"], factory);
	else if(typeof exports === 'object')
		exports["Web3Multicall3Plugin"] = factory(require("web3"), require("web3-eth-abi"));
	else
		root["Web3Multicall3Plugin"] = factory(root["web3"], root["web3-eth-abi"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__413__, __WEBPACK_EXTERNAL_MODULE__81__) => {
return 